module.exports = __webpack_public_path__ + "d5e87397d3a2ca0c56d02c5bdc48777d.svg";